import { generateKeyBetween, generateNKeysBetween } from "fractional-indexing";

export type Sortable = {
  sortIndex: string;
};

export function sort<T extends Sortable>(items: readonly T[]): readonly T[] {
  return [...items].sort((a, b) =>
    a.sortIndex < b.sortIndex ? -1 : a.sortIndex > b.sortIndex ? 1 : 0,
  );
}

export { generateKeyBetween as sortIndexBetween, generateNKeysBetween as nSortIndexesBetween };

export function sortByFn<T>(items: readonly T[], fn: (item: T) => string): readonly T[] {
  return [...items].sort((a, b) => (fn(a) < fn(b) ? -1 : fn(a) > fn(b) ? 1 : 0));
}
